var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-entry",class:_vm.$vuetify.theme.dark ? 'news-entry--dark' : ''},[_c('span',{staticClass:"news-entry__text"},[_vm._v(_vm._s(_vm.text))]),(_vm.img)?_c('img',{staticClass:"news-entry__img",style:(_vm.imgWidthPercent !== 100 ? {width: _vm.imgWidthPercent + '%'} : null),attrs:{"src":_vm.img,"alt":_vm.text}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }